import { jsx as a } from "react/jsx-runtime";
import { forwardRef as f, useRef as c, useImperativeHandle as d, useEffect as s } from "react";
const p = f(
  /**
    * @param {React.ComponentProps<"textarea">} props
    * @param {React.Ref<HTMLTextAreaElement>} ref
    */
  function(r, o) {
    const n = c(null);
    return d(o, () => n.current), s(() => {
      let e = n.current;
      if (e == null) return;
      let i = new AbortController(), u = i.signal;
      return e.addEventListener("input", () => l(e), { signal: u }), e.addEventListener("keydown", () => l(e), { signal: u }), () => i.abort();
    }, []), s(() => {
      let e = n.current;
      e != null && l(e);
    }, [r.value]), /* @__PURE__ */ a("textarea", { rows: 1, ref: n, ...r });
  }
);
function l(t) {
  t.style.removeProperty("height");
  const r = +getComputedStyle(t).fontSize.replace("px", ""), o = Math.max(t.scrollHeight + 2, r + 2);
  t.style.height = o + "px";
}
export {
  p as default
};
